import { ref } from '@vue/composition-api'
import drawsApi from '@/services/api/draws'

export default function useDrawsDashboard() {
  const drafts = ref([])
  const loading = ref(false)

  async function fetchDashboard(year) {
    loading.value = true
    try {
      const params = {}
      if (year != null) params.year = year
      const res = await drawsApi.getDashboard(params)
      const data = res.data.data
      drafts.value = data.drafts != null ? data.drafts : []
    } catch (_) {
      drafts.value = []
    } finally {
      loading.value = false
    }
  }

  async function publishAll(draftId) {
    try {
      const res = await drawsApi.publishAll(draftId)
      return { message: res.data.message || 'All draws published.', type: 'success' }
    } catch (err) {
      const msg = err.response != null && err.response.data != null ? err.response.data.message : 'Failed to publish draws.'
      return { message: msg, type: 'warning' }
    }
  }

  async function queueGenerateAll(draftId) {
    try {
      const res = await drawsApi.queueGenerateAll(draftId)
      return { message: res.data.message || 'Draw generation queued.', type: 'success' }
    } catch (err) {
      const msg = err.response != null && err.response.data != null ? err.response.data.message : 'Failed to queue draw generation.'
      return { message: msg, type: 'warning' }
    }
  }

  async function queueGenerate(eventId, draftId) {
    try {
      const res = await drawsApi.queueGenerate(eventId, { draft_id: draftId })
      return { message: res.data.message || 'Draw generation queued.', type: 'success' }
    } catch (err) {
      const msg = err.response != null && err.response.data != null ? err.response.data.message : 'Failed to queue draw generation.'
      return { message: msg, type: 'warning' }
    }
  }

  return {
    drafts,
    loading,
    fetchDashboard,
    publishAll,
    queueGenerateAll,
    queueGenerate
  }
}



// WEBPACK FOOTER //
// ./src/composables/draws/useDrawsDashboard.js